.navTopbarMobile {
  padding: 0.7rem 1.5rem;
  width: 100vw;
  height: 11vh; /* 100vh - aside's height */
  display: flex;
  justify-content: space-between;
  backdrop-filter: blur(7px);
}

.logoContainer {
  display: flex;
  align-items: center;
}

.navLogo {
  font-family: "Cairo Play Variable", sans-serif;
  font-size: 1.62rem;
  font-weight: 700;
}

.menuIcon {
  font-size: 1.8rem;
  display: flex;
  align-items: center;
}

/* Tablet */
@media (min-width: 768px) {
  .navTopbarMobile {
    padding-inline: 3.3rem;
  }
  .navLogo {
    font-size: 2.1rem;
  }
  .menuIcon {
    font-size: 2.7rem;
  }
}

/* Color scheme when device's theme is light mode */
@media (prefers-color-scheme: light) {
  .navTopbarMobile {
    background-color: rgba(255, 255, 255, 0.91);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  }
  .navLogo,
  .menuIcon {
    color: var(--primary-color);
  }
}

/* Color scheme when device's theme is dark mode */
@media (prefers-color-scheme: dark) {
  .navTopbarMobile {
    background-color: rgba(17, 17, 17, 0.91);
    box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.37);
  }
  .navLogo,
  .menuIcon {
    color: var(--secondary-color);
  }
}
